import React, { useCallback, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import Drawer from 'react-modern-drawer';
import 'react-modern-drawer/dist/index.css';
import "./styles-drawer.css";
import { useDrawerLayer } from './drawerLayerStack';

export const DrawerCustom = ({
    isOpen,
    toggleDrawer,
    children,
    direction = 'right',
    sizeSM = '100%',
    sizeMD = '50%',
    sizeLG = '35%',
    title,
    subtitle,
    footer,
    /** Si es true, overlay/Escape no cierran el drawer (p. ej. mientras guarda). */
    lockClose = false,
}) => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleClose = useCallback(() => {
        if (lockClose) return;
        toggleDrawer();
    }, [lockClose, toggleDrawer]);

    const { zIndex } = useDrawerLayer({
        isOpen,
        onRequestClose: handleClose,
        lockClose,
    });

    return createPortal(
        <Drawer
            open={isOpen}
            onClose={handleClose}
            direction={direction}
            size={windowWidth < 868 ? sizeSM : windowWidth <= 1024 ? sizeMD : sizeLG}
            overlayOpacity={0.4}
            zIndex={zIndex}
            style={{
                backgroundColor: 'transparent',
                height: '100dvh',
                boxShadow: 'none',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginLeft: `${direction === 'left' & windowWidth > 868 ? '15px' : '0px'}`,
                marginRight: `${direction === 'right' & windowWidth > 868 ? '15px' : '0px'}`,
            }}
        >
            <div
                className={`${windowWidth > 868 ? "w-[100%]" : "w-[96%]"} flex flex-col rounded-lg bg-white shadow-md`}
                style={{ height: "96vh", height: "96dvh" }}
            >
                <section className="flex flex-col h-full">
                    {/* Header con tamaño fijo */}
                    <header className="w-full text-gray-900 p-4 flex flex-col justify-between border-b border-gray-200">
                            <h1 className="text-xl font-bold truncate">{title}</h1>
                            <p className="text-sm font-light truncate">{subtitle}</p>
                    </header>
                    {/* Contenido que ocupa el espacio restante */}
                    <main className="flex-1 overflow-auto overscroll-contain">
                        {children}
                    </main>
                    {/* Footer con tamaño fijo */}
                    <footer className="px-4 py-3 border-t border-gray-200">
                        {footer}
                    </footer>
                </section>
                {/* {children} */}
            </div>
        </Drawer>,
        document.body,
    )
}
